<template>
  <div class=" b-fff pa16" style="min-height:100%">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>
<script>
export default {
  name: 'system'
}
</script>
